import { set } from "lodash";

export default function fromErrors(errors) {
  if (!Array.isArray(errors)) return {};
  return errors.reduce((acc, cur) => {
    return set({ ...acc }, cur?.field, cur?.messages);
  }, {});
}
